import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {catchError, map, mergeMap} from "rxjs/operators";
import {EMPTY} from "rxjs";
import {AsService} from "../../_services/http/as.service";
import {
  loadAssociationSegmentsAction,
  loadAssociationSegmentsSuccessAction,
} from "./association-segment.store";

@Injectable()
export class AssociationSegmentEffect {
  constructor(private service: AsService,
              private actions$: Actions) {
  }

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadAssociationSegmentsAction),
      mergeMap((action) => this.service.all().pipe(
        map(payload => (loadAssociationSegmentsSuccessAction({payload}))),
        catchError(() => EMPTY)
      ))
    )
  );
}
